import { validateToken } from "./ValidateToken";
import { ContextManager } from "~/modules/contextManager/ContextManager";

export const validateTokenWrapper = async (accountSid: string, token: string) => {
    return validateToken(ContextManager.newInstance())(accountSid, token);
};
